// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-item[data-v-0c0fb43c] {\n  --padding-start: 0px;\n}\nion-icon[data-v-0c0fb43c] {\n  margin-right: 10px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
